import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

const MAX_MESSAGE_CREDITS = 200;
const MAX_MEDITATION_CREDITS = 10;

const CreditOverview = () => {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const [messageCredits, setMessageCredits] = useState(null);
  const [meditationCredits, setMeditationCredits] = useState(null);

  const fetchCredits = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/check-credits`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const data = await res.json();

      if (res.ok) {
        setMessageCredits(data.monthlyMessageCredit ?? null);
        setMeditationCredits(data.monthlyMeditationCredit ?? null);
      } else {
        console.warn('⚠️ Crédit - format inattendu', data);
      }
    } catch (err) {
      console.error('❌ Erreur fetch crédits :', err);
    }
  };

  useEffect(() => {
    fetchCredits();
  }, []);

  if (!currentUser || currentUser.subscriptionStatus === 'active') {
    return null;
  }

  const renderGauge = (value, max, translationKey) => {
    const percentage = value !== null ? Math.min((value / max) * 100, 100) : 0;

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Box sx={{ position: 'relative', display: 'inline-flex', mr: 1 }}>
          <CircularProgress
            variant="determinate"
            value={100}
            size={22}
            thickness={5}
            sx={{ color: '#a4bac3' }}
          />
          <CircularProgress
            variant="determinate"
            value={percentage}
            size={22}
            thickness={5}
            sx={{
              color: '#000',
              position: 'absolute',
              left: 0,
            }}
          />
        </Box>
        <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
          {value !== null ? `${value} ${t(translationKey)}` : '...'}
        </Typography>
      </Box>
    );
  };

  return (
    <Box sx={{ mb: 2, bgcolor: 'secondary.main', py: 3, px: 3, borderRadius: '8px' }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {t('credit_overview.title')}
      </Typography>

      {renderGauge(messageCredits, MAX_MESSAGE_CREDITS, 'credit_overview.messages_label')}
      {renderGauge(meditationCredits, MAX_MEDITATION_CREDITS, 'credit_overview.meditations_label')}

      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 1 }}
        onClick={() => window.location.href = '/subscribe'}
      >
        {t('credit_overview.subscribe_cta')}
      </Button>
    </Box>
  );
};

export default CreditOverview;
